import { IntegrationIconProps } from './types';

const Yii1 = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5735 2.00037C27.4662 2.97087 29.0918 5.51765 29.0103 8.9735C28.7629 13.2316 25.6949 16.9014 22.3568 20.2825C22.1699 16.1591 21.2789 13.5313 19.8877 9.83609C18.5743 6.11227 22.4143 2.11955 25.5735 2.00037Z"
      fill="url(#paint0_linear_1334_1600)"
    />
    <path
      d="M17.521 16.8196C17.0212 17.814 16.3164 18.9111 15.3365 20.1377C13.6316 22.3002 11.9123 25.8465 12.4411 30.004C20.0811 29.1561 22.0213 22.9688 21.8835 20.2924C21.8785 20.2327 21.8732 20.1728 21.8676 20.1127C21.8673 20.1123 21.867 20.112 21.8667 20.1116C21.8725 20.1717 21.8782 20.2322 21.8835 20.2924C20.6811 18.7342 19.2446 17.6598 17.521 16.8196Z"
      fill="url(#paint1_linear_1334_1600)"
    />
    <path
      d="M18.4469 10.3226C20.3635 13.3171 21.5705 16.748 21.8825 20.2921C20.68 18.7337 19.2434 17.6595 17.5195 16.8193C18.9107 14.0515 18.7154 12.0794 18.4469 10.3226Z"
      fill="url(#paint2_linear_1334_1600)"
    />
    <path
      d="M17.7254 9.26431C14.3432 4.63798 8.48476 2.41753 3.0413 4.58514C2.79139 7.83774 4.17375 12.6745 9.77931 14.2139C10.3968 14.3979 10.9659 14.5634 11.5017 14.7192C13.0142 15.1591 14.2615 15.5219 15.5839 16.0053C16.2667 16.2549 16.9113 16.5225 17.52 16.8193C18.9111 14.0515 18.7158 12.0794 18.4473 10.3227C18.4473 10.3227 17.8571 9.44439 17.7254 9.26431Z"
      fill="url(#paint3_linear_1334_1600)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1600"
        x1="24.3181"
        y1="2.00037"
        x2="24.3181"
        y2="20.2825"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#73B723" />
        <stop offset="1" stopColor="#D8EE61" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1600"
        x1="20.4447"
        y1="20.1992"
        x2="11.3669"
        y2="26.9439"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98C9EA" />
        <stop offset="0.68865" stopColor="#026FB2" />
        <stop offset="1" stopColor="#086EB6" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1334_1600"
        x1="18.8704"
        y1="13.4125"
        x2="22.7108"
        y2="14.9409"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D4C883" />
        <stop offset="1" stopColor="#A1D1A7" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1334_1600"
        x1="3.01367"
        y1="4.58271"
        x2="14.7746"
        y2="15.0705"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D73721" />
        <stop offset="1" stopColor="#F7D768" />
      </linearGradient>
    </defs>
  </svg>
);
export default Yii1;
